export const FETCH_DISCOUNTS_SUCCESS = "FETCH_DISCOUNTS_SUCCESS";
export const FETCH_DISCOUNTS_BEGIN = "FETCH_DISCOUNTS_BEGIN";
export const FETCH_DISCOUNTS_FAILURE = "FETCH_DISCOUNTS_FAILURE";
